import React from "react";
import {extractLocaleString} from "./shared";
import PropTypes from "prop-types";
import BlockView from "./BlockView";
import {
  IndexPageRowStyled,
  IndexPageRowTitleStyled,
  IndexPageRowTrackStyled
} from "./IndexPage.style";

const intersection = 0.5;

const handleElementPositionY = (root, element) => {
  const {top, bottom, height} = element.getBoundingClientRect();

  const targetPosition = {
    top: root.scrollY + top,
    bottom: root.scrollY + bottom,
  },
    rootPosition = {
      top: root.scrollY,
      bottom: root.scrollY + root.innerHeight
    };

  if (targetPosition.bottom - ((height) * intersection) > rootPosition.top &&
    targetPosition.top + ((height) * intersection) < rootPosition.bottom) {
    return true;
  } else {
    return false;
  }
}

const handleElementPositionX = (elements) => {
  const elemArray = Array.from(elements);
  const center = window.innerWidth * 0.5 + 85;
  const elemSizes = elemArray.map((el, i) => {
    const {right, width} = el.getBoundingClientRect();
    return {pos: right, width: width, index: i};
  })

  const arr = elemSizes.reduce((a, b) => {
    return Math.abs(a.pos - center) < Math.abs(b.pos - center) ? a : b;
  })

  elemArray[arr.index].classList.add("animation-start");
  elemArray[arr.index].classList.remove("animation-end");
  elemArray.filter((a, i) => i !== arr.index).forEach((a) => {
    a.classList.remove("animation-start");
    a.classList.add("animation-end");
  });
}

const animationStart = (block) => {
  block.classList.add("animation-start");
  block.classList.remove("animation-end");
}

const animationEnd = (block) => {
  block.classList.add("animation-end");
  block.classList.remove("animation-start");
}

export default class SectionView extends React.Component {
  rowRef = React.createRef();

  componentDidMount() {
    // if (window.clientConfig.isWebDesktop) {
    //   Array.from(this.rowRef.current.children).forEach((block) => {
    //     block.classList.add("animation-end");

    //     block.addEventListener("mouseover", () => animationStart(block));
    //     block.addEventListener("mouseout", () => animationEnd(block));
    //   });

    //   return;
    // }

    this.handleVisibilityBlock(this.rowRef.current, this.rowRef.current.children);
    this.handleVisibilityRow();
    window.addEventListener("scroll", this.handleVisibilityRow);
  }

  componentWillUnmount() {
    // if (window.clientConfig.isWebDesktop) {
    //   Array.from(this.rowRef.current.children).forEach((block) => {
    //     block.removeEventListener("mouseover", () => animationStart(block));
    //     block.removeEventListener("mouseout", () => animationEnd(block));
    //   });

    //   return;
    // }

    window.removeEventListener("scroll", this.handleVisibilityRow);
  }

  handleClick = (block) => {
    this.props.onBlockClick && this.props.onBlockClick(this.props.section, block);
  };

  handleVisibilityRow = () => {
    if (!handleElementPositionY(window, this.rowRef.current)) {
      Array.from(this.rowRef.current.children).forEach((block) => {
        block.classList.remove("animation-start");
        block.classList.add("animation-end");
      })
    } else {
      this.handleVisibilityBlock(this.rowRef.current, this.rowRef.current.children);
    }
  }

  handleVisibilityBlock = (root, elements) => {
    handleElementPositionX(elements);

    root.addEventListener("scroll", () => {
      handleElementPositionX(elements);
    })
  }

  render() {
    let row = this.props.section.blocks.sort((a) => a.type === "wide" ? -1 : 0);
    row = [row.first(), ...row.slice(1).sort((a) => a.type === "normal" ? -1 : 0)];

    return <IndexPageRowStyled>
      < IndexPageRowTitleStyled >
        {extractLocaleString(this.props.section.title)
        }
      </IndexPageRowTitleStyled>
      <IndexPageRowTrackStyled data-value={this.props.dataValue} ref={this.rowRef}>
        {row.map((block, index) => <BlockView
          key={block.name}
          block={block}
          position={index}
          className="index-page__row-item"
          blockRefHandler={this.props.blockRefHandler}
          onClick={(block) => this.handleClick(block)}
        />)}
      </IndexPageRowTrackStyled>
    </IndexPageRowStyled >;
  }
}

SectionView.propTypes = {
  section: PropTypes.object.isRequired,
  position: PropTypes.number,
  onBlockClick: PropTypes.func,
};
